import colors from '@settings/styleSettings'
import { getTresholdForBloodPressureValueIndex } from '@util/tresholdUtil'

export function getRisks(has, dm, cholesterol, imc) {
  // Se não houver exame laboratorial (colesterol não veio), não calculamos risco.
  if (cholesterol === '') return -1
  const diagnostics = []
  if (has) diagnostics.push('HAS (Hipertensão Arterial Sistêmica)')
  if (dm) diagnostics.push('DM (Diabetes Mellitus)')
  if (cholesterol) diagnostics.push('Dislipidemia')
  if (imc > 25) diagnostics.push('IMC')
  return diagnostics
}

export function getRiskClassification(risksLength) {
  if (risksLength === -2) return 'Sem coleta'
  if (risksLength === -1) return 'Não coletado'
  if (risksLength === 0) return 'Sem risco'
  if (risksLength === 1) return 'Baixo'
  if (risksLength === 2) return 'Moderado'
  if (risksLength >= 3) return 'Alto'
  return null
}

export function getRisksForDisplay(risks) {
  if (!Array.isArray(risks) || risks.length === 0) return '.'
  return ` de ${risks
    .map((risk, idx) => {
      if (idx === 0) return risk
      if (idx === risks.length - 1) return ` e ${risk}`
      return `, ${risk}`
    })
    .join('')}.`
}

export function colorByRisks(risks) {
  if (risks === -2) return colors.mostStrongestGray
  if (risks === -1) return colors.mostStrongestGray
  if (risks === 0) return colors.strongBlue
  if (risks === 1) return colors.primary
  if (risks === 2) return colors.strongYellow
  return colors.strongRed
}

export function getHypertensiveRisk(systBloodPressure, diastBloodPressure) {
  if (!systBloodPressure || !diastBloodPressure) return 0

  const index = getTresholdForBloodPressureValueIndex(
    systBloodPressure,
    diastBloodPressure
  )

  if (index === 3) return 2
  if (index === 2) return 1
  return 0
}

export function getDiabeticRisk(glucose) {
  if (glucose > 180) return 3
  if (glucose >= 126 && glucose <= 180) return 2
  if (glucose <= 125 && glucose >= 100) return 1
  return 0
}

export function getDyslipidemiaRisk(
  triglycerides,
  totalCholesterol,
  hdlCholesterol,
  ldlCholesterol
) {
  const sameP = triglycerides >= 150 || totalCholesterol >= 190 || hdlCholesterol < 40
  if (ldlCholesterol >= 190) return 3
  if (ldlCholesterol >= 160) return 2
  if (sameP || ldlCholesterol >= 130) return 1
  return 0
}

export function getImcRisk(weight, height) {
  const heightInMeters = height / 100
  const imc = weight / (heightInMeters * heightInMeters)
  if (imc > 30) return 2
  if (imc > 25) return 1
  return 0
}
